<template>
  <button @click="reset()">
    <slot></slot>
  </button>
</template>

<script>
import EventBus from "@/eventBus";

export default {
  methods: {
    reset() {
      EventBus.$emit("resetAllFilters");
      let filters = this.$store.state.filter;

      for (let k in filters) {
        if (k != "argerd" && k != "verd" && k != "ekinn") {
          if (filters[k].length > 0) {
            filters[k] = [];
          }
        }
      }

      const oldCarsSrartParams = this.$store.state.moduleOldCars.startParams;

      filters.verd = [
        oldCarsSrartParams.verd.min,
        oldCarsSrartParams.verd.max
      ];

      if (filters.argerd) {
        filters.argerd = [
          oldCarsSrartParams.argerd.min,
          oldCarsSrartParams.argerd.max
        ];
      }

      if (filters.ekinn) {
        filters.ekinn = [
          oldCarsSrartParams.ekinn.min,
          oldCarsSrartParams.ekinn.max
        ];
      }


      filters.verdtilbod = false;
      filters.parking = false;
      filters.notInCountry = false;
      filters.discount = false;
    }
  }
};
</script>
